import { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "oidc-react";

import Login from "./pages/Login";
import Home from "./pages/Home";
import LessonDetails from "./pages/LessonDetails";
import StudentProgress from "./pages/StudentProgress";
import NotFound from "./pages/NotFound";
import ClassroomManagementPage from "./pages/ClassroomManagement";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading && !auth.userData && location.pathname !== "/login") {
      navigate("/login");
    }
  });
  if (auth.isLoading) {
    return <p>Loading</p>;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Home />} />
      <Route path="/course/:courseSlug">
        <Route
          path="section/:sectionId/lesson/:lessonId"
          element={<LessonDetails />}
        />
        <Route
          path="section/:sectionId/lesson/:lessonId/progress"
          element={<StudentProgress />}
        />
        <Route path="classroom" element={<ClassroomManagementPage />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
